enum DefaultPaymentCodes {
  USD = 'USD',
  US = 'US',
}

export const DEFAULT_PAYMENT_CURRENCY = DefaultPaymentCodes.USD;
export const DEFAULT_PAYMENT_COUNTRY = DefaultPaymentCodes.US;
